import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "RazpoloÅ¾enja",
  "description": "",
  "published": "2006-09-24T00:00:00.000Z",
  "redirect_from": ["/blog/razpoloenja/swizec/381"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`V majhnih urah jutra razpet si med sencami modrega in temino Å¾ivo rdeÄega. Ne moreš odloÄiti se ali ustvarjal bi prava dela umetnosti ali lotil se del, ki ti jih šef s pomoÄjo puške nalaga. Obe moÅ¾nosti sta enako grozni in bi te pustili strganega in pretresenega do kosti.`}</p>
    <p>{`Ampak eno lahko opraviš skorajda preprosto z aktivacijo programov, drugi pa zahteva, da magiÄno proizvedeš svetlobo iz mrtve svetilke in slabo postavljene neuporabne glavne luÄi. Kaj torej storiš? Å½diš v temi in se utapljaš v samopomilovanju seveda.`}</p>
    <p>{`Dokler iz predala ne pride mimo osupljiva stripknjiga in ti ukrade delÄek umirajoÄe pozornosti. SkoÄi vate v vsej svoji mogoÄnosti in ko izveš, da je stripar tudi tisti glasbenik Äigar glasbi prisluškuješ Å¾e veÄ tednov, si toplo preseneÄen in vesel.`}</p>
    <p>{`In potem, ko listaš in listaš, odkriješ še polno gostujoÄih striparjev, ki so na knjigi pustili svoj osupljivi peÄat, ljudje kot Maxwell Atoms in drugi podobni geniji... knjiga je preprosto vredna vse tvoje ljubezni in obÄudovanja.`}</p>
    <p><img parentName="p" {...{
        "src": "/includes/editor_upload/Image/kscan_0177.png",
        "alt": "The Book Of Deady"
      }}></img></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      